import {createAction} from 'redux-actions';
import * as ACTION from './constants';

export const unlinkOrder = createAction(ACTION.UNLINK_ORDER.REQUEST, (packageId) => packageId);
export const beginUnlinkOrder = createAction(ACTION.BEGIN_UNLINK_ORDER, () => {});
export const endUnlinkOrder = createAction(ACTION.END_UNLINK_ORDER, () => {});